export default "__VITE_ASSET__Cul7LQe8__"